// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicFileActions_root__33vEZ","fileName":"PlasmicFileActions_fileName__1e_mr","removeBtn":"PlasmicFileActions_removeBtn__1-v2Y"};